import React from "react";
import "../Navigation/css/NavBar.scss";

export default function SupportedMediaTypes() {
    return (
        <div>
            Supported Media Types
        </div>
    )
}